import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Banner informativ de cookies (Legea 506/2004 + Directiva ePrivacy).
// SSMPlatform folosește DOAR storage strict necesar (token JWT, temă, limbă, cheie semnătură),
// deci NU e nevoie de consimțământ activ (opt-in) — un banner informativ este suficient.
// Dacă în viitor se adaugă cookies non-esențiale (analytics, marketing), acest banner trebuie
// transformat într-unul cu opt-in activ (Accept/Refuz), conform CJUE C-673/17 Planet49.
// Textul e bilingv (RO/EN) ales după limba curentă i18next, fără a depinde de chei noi în locale.
const STORAGE_KEY = 'cookie_notice_ack';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      // localStorage indisponibil (mod privat strict) — nu afișăm banner, nu blocăm aplicația.
    }
  }, []);

  const handleAck = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label={t('cookieConsent.ariaLabel')}
      className="fixed bottom-0 inset-x-0 z-50 bg-white dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 shadow-lg"
    >
      <div className="max-w-5xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-xs text-slate-600 dark:text-slate-300 flex-1">
          {t('cookieConsent.message')}{' '}
          <Link
            to="/legal/cookies"
            className="text-primary-600 dark:text-primary-300 underline whitespace-nowrap"
          >
            {t('cookieConsent.details')}
          </Link>
        </p>
        <button
          onClick={handleAck}
          className="self-end sm:self-auto px-4 py-1.5 text-sm font-medium rounded-md bg-primary-600 text-white hover:bg-primary-700 transition-colors whitespace-nowrap"
        >
          {t('cookieConsent.ack')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
